import { render, staticRenderFns } from "./incomeCostConfirmDetail.vue?vue&type=template&id=bfc66da6&scoped=true"
import script from "./incomeCostConfirmDetail.vue?vue&type=script&lang=js"
export * from "./incomeCostConfirmDetail.vue?vue&type=script&lang=js"
import style0 from "./incomeCostConfirmDetail.vue?vue&type=style&index=0&id=bfc66da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc66da6",
  null
  
)

export default component.exports